module.exports = __webpack_public_path__ + "img/snake.9c1142c1.svg";